import { ForwardTradeView } from "./forward-trade-view";
import { useForwardTrade } from "./use-forward-trade";

export const ForwardTrade = () => {
  const logic = useForwardTrade();

  return <ForwardTradeView {...logic} />;
};
